import { DraftJsEditor } from "./DraftJsEditor";
export default DraftJsEditor;
export * from "./DraftJsEditor";
